import { Button, Typography, styled } from "@mui/material";

export const StopCastingButton = styled(Button)(({ theme }) => ({
    ...theme.typography.button,
    height: '4.5vh',
    width:'19vh',
    backgroundColor: '#788BF9',
    fontSize: '1.6vh',
    fontWeight: 700,
    color:'#FFFFFF',
    '&:hover': {
      backgroundColor: '#788BF9',
    },
    '&:disabled': {
      color: 'white',
      backgroundColor: '#DADEEA'
    },
    textTransform: 'none',
    borderRadius:'5px',
  }));

  export const ProjectNameTypo = styled(Typography)({
    color:'#434444',
    fontSize:'2vh',
    fontWeight:700,
 })

 export const ProjectDescTypo = styled(Typography)({
    color:'#434444',
    fontSize:'1.5vh',
    fontWeight:400
 })

 export const CastDetails = styled('div')({
    display:'flex',   
    marginTop:'2%',
    position:'relative',
    width:'100%'
 })

 export const InnerContainer = styled('div')({
    paddingLeft:'2%',
 })
 
 export const ButtonContainer = styled('div')({
    position:'absolute' ,
    display:'flex' , 
    width:'100%' , 
    justifyContent:'center'
 })